export default __webpack_public_path__ + "assets/01dc75edc371c28ab83f5adedcd871e4.png";